import r from"./function-uncurry-this.js";var o=r,t=o({}.isPrototypeOf);export{t as default};
